import type { ThemeInfo } from './presentation';
export const assetUrl = (relative: string) => new URL(import.meta.env.BASE_URL + relative, document.baseURI).href;
export async function loadCatalog(): Promise<{ themes: ThemeInfo[] }> {
  const response = await fetch(assetUrl('themes/catalog.json'));
  if (!response.ok) throw new Error('Theme catalog failed'); return response.json();
}
